import React, { ReactNode } from 'react';

import { DefaultBsComponent, PayFitColor } from '../../types/module';
import { container } from '../../styles/themes';
import { textTitle2 } from '../../styles/typography';
import { classNames } from '../../utils/style';

import { applyTextStyles } from './logic';
import { applyBgColor } from '../../utils/utils';

export interface KeyFiguresProps extends DefaultBsComponent {
  title?: string;
  backgroundColor?: PayFitColor;
  isDark?: boolean;
  useCards?: boolean;
  hasLineAbove?: boolean;
  children: ReactNode[];
  hasThreeColumnsLayout?: boolean;
  className: string;
}

export const KeyFigures = ({
  title = '',
  children,
  backgroundColor = 'blue',
  isDark = false,
  hasThreeColumnsLayout = false,
  className = '',
  as: Component = 'section',
}: KeyFiguresProps) => {
  return (
    <Component
      id={title?.replace(/\W+/g, '-') ?? null}
      className={classNames(
        'KeyFigures',
        `${applyTextStyles(isDark, backgroundColor)} ${className}`,
        applyBgColor(backgroundColor, isDark, '', !isDark ? 51 : undefined),
      )}
    >
      <div className={classNames(container)}>
        <h2 className={classNames(textTitle2, 'mb-10 md:mb-14')}>{title}</h2>
        <div
          className={classNames(
            !hasThreeColumnsLayout && 'lg:justify-end',
            'flex',
          )}
        >
          <div
            className={`${
              !hasThreeColumnsLayout ? 'lg:w-2/3' : 'w-full'
            } flex  md:justify-end`}
          >
            <div
              className={classNames(
                !hasThreeColumnsLayout && 'flex-col',
                'flex flex-wrap justify-between w-full md:flex-row',
              )}
            >
              {children}
            </div>
          </div>
        </div>
      </div>
    </Component>
  );
};
